var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('v-container',[_c('salary-table',{attrs:{"classes":_vm.salaryReport.classes,"salary-report":_vm.salaryReport,"loading":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }